import { CommonCard } from "../../CommonCard/CommonCard";
import { ViewProps } from "../types";

export const BoxTypeList = ({
  products,
  show,
  handleImageClick,
  productSize,
  groupedProducts,
  groupByCategory,
  setSelectedItem,
}: ViewProps) => {
  if (groupByCategory) {
    return (
      <div className="px-5 p-4 bg-gray-100">
        {groupedProducts?.map((item) => (
          <div key={item.id} data-tab-id={item.id}>
            <h3 className="py-6">{item.name}</h3>
            <div className="mb-4 mt-2 pl-0 flex flex-wrap gap-4">
              {item.items.map((item, index) => (
                <CommonCard
                  key={item.id}
                  productSize={productSize}
                  imageSource={item.image}
                  imageAlt={item.title}
                  title={item.title}
                  category={item.category.name}
                  description={item.description}
                  price={item.price}
                  weight={item.weight}
                  calories={item.calories}
                  show={show}
                  isBox
                  onClick={() => {
                    setSelectedItem(item);
                    handleImageClick(index);
                  }}
                  nutritionalInfo={item?.nutritional_information}
                  ingredients={item?.ingredients}
                  allergens={item?.allergens}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="px-5 mb-4 p-4 flex flex-wrap gap-4">
      {products?.data?.map((item, index) => (
        <CommonCard
          key={index}
          productSize={productSize}
          imageSource={
            item.attributes?.media?.data?.[0]?.attributes?.formats?.thumbnail
              ?.url
          }
          imageAlt={
            item.attributes?.media?.data?.[0]?.attributes?.alternativeText
          }
          title={item.attributes?.title}
          category={item.attributes?.category?.data?.attributes?.name}
          description={item.attributes?.description}
          price={item.attributes?.price}
          weight={item.attributes?.weight}
          calories={item.attributes?.total_calories}
          show={show}
          isBox
          onClick={() => handleImageClick(index)}
        />
      ))}
    </div>
  );
};
